import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldCheck, FileText, Download } from "lucide-react";

export default function ClearanceDownload() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/public/clearance/${token}`).then((r) => setMeta(r.data))
      .catch(() => setErr("This clearance link is not valid or has expired."));
  }, [token]);

  if (err) return <div className="min-h-screen grid place-items-center text-cass-slate px-6 text-center" data-testid="clearance-error">{err}</div>;
  if (!meta) return <div className="min-h-screen grid place-items-center text-cass-slate">Loading…</div>;

  return (
    <div className="bg-cass-bone min-h-screen grid place-items-center px-4 py-16">
      <div className="max-w-[560px] w-full bg-white rounded-2xl shadow-xl ring-1 ring-black/5 p-10 text-center" data-testid="clearance-download">
        <div className="font-alt font-extrabold text-cass-navy text-xl mb-6">{meta.from_name}</div>
        <FileText className="w-12 h-12 text-cass-teal mx-auto mb-4" />
        <h1 className="font-display text-2xl md:text-3xl font-bold text-cass-navy mb-2">Professional clearance letter</h1>
        <p className="text-cass-slate mb-8">
          {meta.from_name} has sent you a professional clearance request regarding
          <span className="font-semibold text-cass-navy"> {meta.business_name}</span>. You can view and download the letter securely below.
        </p>
        <Button className="bg-cass-teal text-white rounded-full px-8 h-12" data-testid="clearance-download-btn"
          onClick={() => window.open(`${API}/public/clearance/${token}/pdf`, "_blank")}>
          <Download className="w-4 h-4 mr-2" />View clearance letter (PDF)
        </Button>
        <div className="mt-8 flex items-center justify-center gap-2 text-xs text-cass-slate">
          <ShieldCheck className="w-4 h-4 text-cass-teal" />Secure document link
        </div>
      </div>
    </div>
  );
}
